export const SPORTS = ['Beach Tennis', 'Futevôlei', 'Pickleball', 'Vôlei'] as const;

export const NEXT_GAME = {
  title: 'Racha nível B · Areia 3',
  location: 'Praia Norte',
  spotsLabel: '3/4 vagas',
  startsInLabel: 'em 2h',
};

export interface NearbyArena {
  id: string;
  name: string;
  distanceKm: number;
  courts: number;
  surface: string;
  rating: number;
  priceFrom: number;
  /** Arena cadastrada na demonstração: sem nota ainda, mostra o selo "Nova". */
  isNew?: boolean;
}

export const NEARBY_ARENAS: NearbyArena[] = [
  {
    id: 'praia-norte',
    name: 'Arena Praia Norte',
    distanceKm: 1.2,
    courts: 6,
    surface: 'areia',
    rating: 4.8,
    priceFrom: 60,
  },
  {
    id: 'beach-club-meireles',
    name: 'Beach Club Meireles',
    distanceKm: 2.8,
    courts: 4,
    surface: 'coberta',
    rating: 4.6,
    priceFrom: 75,
  },
  {
    id: 'sand-coco-sports',
    name: 'Sand Cocó Sports',
    distanceKm: 4.1,
    courts: 8,
    surface: 'mista',
    rating: 4.7,
    priceFrom: 55,
  },
];
